import { withStyles } from '@material-ui/core/styles';
import { TableSortLabel } from '@material-ui/core';

export const AntTableSortLabel = withStyles({
    icon: {
        opacity: 1,
    },
})(TableSortLabel);
